import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as selectorsCartoes from 'store/cartao/reducer';
import * as actionsCartoes from 'store/cartao/actions';
import DefaultSelectV2 from '../DefaultSelectV2';

const CartaoSelectV2 = ({ cartoesOptions, onSelect, value, error, findCartoesOptions, disabled, isRequired }) => {
  const handleChange = (event) => onSelect(event.target.value);
  useEffect(() => {
    findCartoesOptions();
  }, [findCartoesOptions]);

  return (
    <DefaultSelectV2
      error={error}
      disabled={disabled}
      isRequired={isRequired}
      label="Cartão Corporativo"
      name="cartao"
      optionLabel="codigo"
      onSelect={handleChange}
      options={cartoesOptions || []}
      showEmpty
      value={value}
    />
  );
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsCartoes }, dispatch);
const mapStateToProps = (state) => ({ cartoesOptions: selectorsCartoes.getCartoesOptions(state) });
export default connect(mapStateToProps, mapDispatchToProps)(CartaoSelectV2);
